var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.show)?_c('div',{staticClass:"loading_content"},[_c('div',{staticClass:"loading"},[_c('lottie',{attrs:{"options":_vm.defaultOptions,"height":120,"width":120},on:{"animCreated":_vm.handleAnimation}}),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$t('message.loading')))])],1)]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2c65863e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/loading2.vue
// module id = null
// module chunks = 